import React, { useState, useMemo } from 'react';
import { useIntl } from 'react-intl';
import get from 'lodash.get';

import Context from './Context';
import { useAuth } from 'providers/Auth';
import * as Client from 'api/client';
import { useToast } from 'providers/Toast';

const getAnnotationFns = (annotations) => {
  const findAnnotation = (key = '') =>
    annotations.find((annotation) => annotation.key === key) || {};
  const findCustomAnnotations = () =>
    annotations.filter(
      (annotation = {}) =>
        ((annotation.key || '').split('_')[1] || '').length === 36,
    ) || [];
  const findAnnotations = (keys = []) => keys.map((key) => findAnnotation(key));

  return {
    findAnnotation,
    findAnnotations,
    findCustomAnnotations,
  };
};

const Provider = ({ children }) => {
  const [order, setOrder] = useState({});
  const [orders, setOrders] = useState([]);
  const { auth } = useAuth();
  const { danger } = useToast();
  const intl = useIntl();
  const { userId, idToken } = auth;

  const getOrder = (id) => {
    return Client.getOrder(userId, id, idToken).then((res) => {
      if (!res.err) setOrder(res);
      return !res.err ? res : false;
    });
  };

  const getPaymentLink = (orderId) =>
    Client.getPaymentLink(userId, idToken, orderId).then((res) => {
      if (!res.err) return res;
      return !res.err ? res : false;
    });

  const getOrders = () =>
    Client.getOrders(userId, idToken).then((res) => {
      if (!res.err) setOrders(res);
      return !res.err ? res : false;
    });

  const submitOrder = (customerMeta = {}, cartStr = '') =>
    Client.submitOrder(userId, idToken, customerMeta, cartStr).then((order) => {
      const errorText = order.message;
      if (order.err)
        danger(errorText || intl.formatMessage({ id: 'system_busy_msg' }));
      if (order && order.id) setOrder(order);
      return !order.err ? order : false;
    });

  const annotations = get(order, 'annotations', []);
  const { findAnnotation, findAnnotations, findCustomAnnotations } = useMemo(
    () => getAnnotationFns(annotations),
    [annotations],
  );

  const props = {
    order,
    orders,
    getOrders,
    getOrder,
    submitOrder,
    getPaymentLink,
    findAnnotation,
    findAnnotations,
    findCustomAnnotations,
  };

  return <Context.Provider value={{ ...props }}>{children}</Context.Provider>;
};

export default Provider;
